import React from 'react'

import EntityPage from '../components/EntityPage'
import Linkify from '../components/Linkify'
import StatusBadge from '../components/StatusBadge'
import { fmtDate } from '../components/format'
import { usePersonLabels, joinLabels } from '../api/people'

const Stays: React.FC = () => {
  const labels = usePersonLabels()

  return (
    <EntityPage
      entity="stays"
      title="🏨 Stays"
      description="Hotels & rentals outside the villa week — add your pre/post trip extensions here. Booked stays appear on the calendar."
      addLabel="Add stay"
      emptyHint="No extra stays yet — add the first one."
      columns={[
        { key: 'traveler_ids', label: 'Travelers', render: (r) => joinLabels(labels, r.traveler_ids) },
        { key: 'hotel', label: 'Hotel / rental' },
        { key: 'town', label: 'Town' },
        { key: 'check_in', label: 'Check-in', render: (r) => fmtDate(r.check_in) },
        { key: 'check_out', label: 'Check-out', render: (r) => fmtDate(r.check_out) },
        { key: 'status', label: 'Status', render: (r) => <StatusBadge status={r.status} /> },
        { key: 'confirmation', label: 'Conf #' },
        { key: 'address', label: 'Address', render: (r) => <Linkify text={r.address} /> },
        { key: 'notes', label: 'Notes', render: (r) => <Linkify text={r.notes} /> },
      ]}
      fields={[
        { name: 'traveler_ids', label: 'Travelers', type: 'people' },
        { name: 'hotel', label: 'Hotel / rental name', type: 'text', placeholder: 'Rancho Relaxo' },
        { name: 'town', label: 'Town', type: 'text', required: true, placeholder: 'Playas del Coco' },
        { name: 'check_in', label: 'Check-in', type: 'date', required: true },
        { name: 'check_out', label: 'Check-out', type: 'date', required: true },
        {
          name: 'status', label: 'Status', type: 'select',
          options: [
            { value: 'booked', label: 'Booked' },
            { value: 'planning', label: 'Planning' },
          ],
        },
        { name: 'confirmation', label: 'Confirmation #', type: 'text' },
        { name: 'address', label: 'Address', type: 'textarea', placeholder: 'Street address, or "Google Maps: …"' },
        { name: 'notes', label: 'Notes', type: 'textarea' },
      ]}
      blank={{ status: 'booked' }}
    />
  )
}

export default Stays
